import { render, staticRenderFns } from "./updateinstitution.vue?vue&type=template&id=24441e82&"
import script from "./updateinstitution.vue?vue&type=script&lang=js&"
export * from "./updateinstitution.vue?vue&type=script&lang=js&"
import style0 from "./updateinstitution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports